import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Output } from '@angular/core'
import { Router } from '@angular/router'
import { LandingPageSectionContainerModule } from '@landing-page/components/container/landing-page-section-container.module'
import { SystemResponseModule } from '@shared-ui-lib/system-response/system-response.module'

@Component({
    standalone: true,
    imports: [
        CommonModule,
        LandingPageSectionContainerModule,
        SystemResponseModule,
    ],
    selector: 'app-landing-page-register-form-error',
    templateUrl: './landing-page-register-form-error.component.html',
})
export class LandingPageRegisterFormErrorComponent {
    constructor(private router: Router) {}

    @Output()
    readonly retryClick = new EventEmitter<void>()

    handleServiceDeskClick() {
        this.router.navigate(['/contact'])
    }

    handleTryAgainClick() {
        this.retryClick.emit()
    }
}
